<template>
  <div>
    <div v-for="(option, index) in listOptions" :key="index" class="cyber-day--check-options" >
      <label class="label--cyber-options">{{ option.label }} <span v-if="option.required" class="text-danger">*</span></label>
      <b-form-group  v-slot="{ ariaDescribedby }" required="true" :state="option.active !== undefined" invalid-feedback="Este campo es requerido">
        <b-form-radio v-model="option.active" :aria-describedby="ariaDescribedby" :name="option.name" :value="true">Si</b-form-radio>
        <b-form-radio v-model="option.active" :aria-describedby="ariaDescribedby" :name="option.name" :value="false">No</b-form-radio>
      </b-form-group>
      <div v-if="option.showTimer && option.active" class="cyber-day--timer-container">
        <div>
          <b-form-timepicker v-model="option.timeStart" locale="en" :state="!!option.timeStart"></b-form-timepicker>
          <label v-if="!option.timeStart" class="text-danger">Este campo es requerido</label>
        </div>
        <div>
          <b-form-timepicker v-model="option.timeEnd" locale="en" :state="!!option.timeEnd"></b-form-timepicker>
          <label v-if="!option.timeEnd" class="text-danger">Este campo es requerido</label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    listOptions: {
      type: Array,
      default: () => {
        return []
      }
    },
    sizeWeek: {
      type: Number,
      default: () => 0
    }
  },
  watch: {
    listOptions: {
      handler(newVal) {
        this.checkForm()
        this.$emit('update:listOptions', newVal)
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.checkForm()
  },
  methods: {
    checkForm() {
      let hasError = false
      for (const key in this.listOptions) {
        const option = this.listOptions[key]
        if (option.showTimer && option.active) {
          if (!option.timeStart || !option.timeEnd) {
            hasError = true
            break
          }
        } else if (option.active === undefined && option.required) {
          hasError = true
          break
        }
      }
      this.$emit('disableSend', hasError)
    }
  }
}
</script>
<style lang="scss">
  .cyber-day--check-options {
    padding: 15px 0;

    .label--cyber-options {
      font-family: Montserrat;
      font-weight: 400;
      font-size: 14.02px;
      line-height: 100%;
      letter-spacing: 0;
      color: #868686;
    }
  }
  .cyber-day--timer-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    padding: 30px 0 0;
  }
</style>